import { render, staticRenderFns } from "./WServerDataTable.vue?vue&type=template&id=33c268fa&scoped=true&"
import script from "./WServerDataTable.vue?vue&type=script&lang=js&"
export * from "./WServerDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c268fa",
  null
  
)

export default component.exports